/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { shopProductControllerCreate } from '../fn/shop-product/shop-product-controller-create';
import { ShopProductControllerCreate$Params } from '../fn/shop-product/shop-product-controller-create';
import { shopProductControllerFindById } from '../fn/shop-product/shop-product-controller-find-by-id';
import { ShopProductControllerFindById$Params } from '../fn/shop-product/shop-product-controller-find-by-id';
import { shopProductControllerRemove } from '../fn/shop-product/shop-product-controller-remove';
import { ShopProductControllerRemove$Params } from '../fn/shop-product/shop-product-controller-remove';
import { shopProductControllerSearch } from '../fn/shop-product/shop-product-controller-search';
import { ShopProductControllerSearch$Params } from '../fn/shop-product/shop-product-controller-search';
import { shopProductControllerSearchPublic } from '../fn/shop-product/shop-product-controller-search-public';
import { ShopProductControllerSearchPublic$Params } from '../fn/shop-product/shop-product-controller-search-public';
import { shopProductControllerUpdate } from '../fn/shop-product/shop-product-controller-update';
import { ShopProductControllerUpdate$Params } from '../fn/shop-product/shop-product-controller-update';
import { shopProductControllerUpdateStatus } from '../fn/shop-product/shop-product-controller-update-status';
import { ShopProductControllerUpdateStatus$Params } from '../fn/shop-product/shop-product-controller-update-status';
import { ShopProductDto } from '../models/shop-product-dto';

@Injectable({ providedIn: 'root' })
export class ShopProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shopProductControllerSearch()` */
  static readonly ShopProductControllerSearchPath = '/api/shop-products';

  /**
   * 상품 목록 조회 (관리자).
   *
   * 전체 상품 목록을 페이지 기반으로 조회합니다. (판매중지 포함)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerSearch$Response(params: ShopProductControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = shopProductControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 목록 조회 (관리자).
   *
   * 전체 상품 목록을 페이지 기반으로 조회합니다. (판매중지 포함)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerSearch(params: ShopProductControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.shopProductControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `shopProductControllerCreate()` */
  static readonly ShopProductControllerCreatePath = '/api/shop-products';

  /**
   * 상품 등록 (관리자).
   *
   * 새로운 상품을 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductControllerCreate$Response(params: ShopProductControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 등록 (관리자).
   *
   * 새로운 상품을 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductControllerCreate(params: ShopProductControllerCreate$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

  /** Path part for operation `shopProductControllerSearchPublic()` */
  static readonly ShopProductControllerSearchPublicPath = '/api/shop-products/public';

  /**
   * 상품 목록 조회 (클라이언트).
   *
   * 판매중/품절 상품만 노출합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerSearchPublic()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerSearchPublic$Response(params: ShopProductControllerSearchPublic$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = shopProductControllerSearchPublic(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 목록 조회 (클라이언트).
   *
   * 판매중/품절 상품만 노출합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerSearchPublic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerSearchPublic(params: ShopProductControllerSearchPublic$Params, context?: HttpContext): Observable<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.shopProductControllerSearchPublic$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ShopProductDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `shopProductControllerFindById()` */
  static readonly ShopProductControllerFindByIdPath = '/api/shop-products/{id}';

  /**
   * 상품 상세 조회.
   *
   * 상품 ID로 상세 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerFindById$Response(params: ShopProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 상세 조회.
   *
   * 상품 ID로 상세 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerFindById(params: ShopProductControllerFindById$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

  /** Path part for operation `shopProductControllerRemove()` */
  static readonly ShopProductControllerRemovePath = '/api/shop-products/{id}';

  /**
   * 상품 삭제 (관리자).
   *
   * 상품을 삭제합니다. (소프트 삭제)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerRemove$Response(params: ShopProductControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = shopProductControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 삭제 (관리자).
   *
   * 상품을 삭제합니다. (소프트 삭제)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shopProductControllerRemove(params: ShopProductControllerRemove$Params, context?: HttpContext): Observable<void> {
    const resp = this.shopProductControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `shopProductControllerUpdate()` */
  static readonly ShopProductControllerUpdatePath = '/api/shop-products/{id}';

  /**
   * 상품 수정 (관리자).
   *
   * 상품 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductControllerUpdate$Response(params: ShopProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 수정 (관리자).
   *
   * 상품 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductControllerUpdate(params: ShopProductControllerUpdate$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

  /** Path part for operation `shopProductControllerUpdateStatus()` */
  static readonly ShopProductControllerUpdateStatusPath = '/api/shop-products/{id}/status';

  /**
   * 상품 판매 상태 변경 (관리자).
   *
   * 판매 상태를 변경합니다. 재고 상태에 따라 자동 조정됩니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopProductControllerUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductControllerUpdateStatus$Response(params: ShopProductControllerUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
    const obs = shopProductControllerUpdateStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 상품 판매 상태 변경 (관리자).
   *
   * 판매 상태를 변경합니다. 재고 상태에 따라 자동 조정됩니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shopProductControllerUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopProductControllerUpdateStatus(params: ShopProductControllerUpdateStatus$Params, context?: HttpContext): Observable<ShopProductDto> {
    const resp = this.shopProductControllerUpdateStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShopProductDto>): ShopProductDto => r.body)
    );
  }

}
